import React from "react";
import { useTranslation } from "react-i18next";
import { useGetCartQuery } from "../../../../cart/api/cartApi";
import { useSelectShippingRate } from "../../../../cart/hooks/useSelectShippingRate";

const ShippingMethods: React.FC = () => {
  const { t } = useTranslation();
  const { data: cart } = useGetCartQuery();
  const { handleSelectShippingRate, isSelectingRate } = useSelectShippingRate();

  // Don't render if shipping is not needed
  if (!cart || !cart.needsShipping) {
    return null;
  }

  const shippingRates = cart.shippingRates || [];

  // If no rates found
  if (shippingRates.length === 0) {
    return (
      <div className="checkout-form__section">
        <div className="alert alert--warning">
          {t(
            "cartShippingCalculator.noRates",
            "No shipping options were found for your address.",
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="checkout-form__section checkout-form__section--shipping-methods">
      <h3 className="checkout-form__section-title">
        {t("cartShippingCalculator.title", "Shipping Options")}
      </h3>

      <div className="shipping-methods-list">
        {shippingRates.map((rate) => (
          <label
            key={rate.rateId}
            className={`shipping-method-option ${
              rate.selected ? "is-selected" : ""
            }`}
          >
            <div className="shipping-method-option__radio">
              <input
                type="radio"
                name="shipping_method"
                value={rate.rateId}
                checked={rate.selected}
                onChange={() =>
                  handleSelectShippingRate({
                    package_id: 0, // Store API usually flattens this to 0 unless multiple packages
                    rate_id: rate.rateId,
                  })
                }
                disabled={isSelectingRate}
              />
            </div>
            <div className="shipping-method-option__details">
              <span className="shipping-method-option__name">{rate.name}</span>
              {rate.description && (
                <span className="shipping-method-option__desc">
                  {rate.description}
                </span>
              )}
              {rate.deliveryTime && (
                <span className="shipping-method-option__time">
                  {rate.deliveryTime}
                </span>
              )}
            </div>
            <div className="shipping-method-option__price">{rate.price}</div>
          </label>
        ))}
      </div>
    </div>
  );
};

export default ShippingMethods;
